import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  DataResponse,
  GetBackofficeFlagsTreemapResponseDataSchema,
  GetBackofficeFlagsTreemapSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeFlagsTreemapSchema>
type Response = DataResponse<z.infer<typeof GetBackofficeFlagsTreemapResponseDataSchema>>

export const getBackofficeFlagsTreemapQuery = ({ query }: { query: Query }) =>
  queryOptions({
    queryKey: ["backofficeFlagsTreemap", query],
    staleTime: 10 * MINUTES_TO_MILLIS,
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/flags/treemap", { params: query })
      return data.data
    },
  })
